import Cookies from "js-cookie";
import { Navigate } from "react-router-dom";

export default function Ward({ route }) {
  const token = Cookies.get("token");

  if (route.redirect) {
    return <Navigate to={route.redirect} />;
  }
  if (
    (route.path === "/login" ||
      route.path === "/reset-password" ||
      route.path === "/reset-activate" ||
      route.path === "/activate") &&
    token
  ) {
    return <Navigate to="/dashboard" />;
  }
  if (route.public) {
    return route.element;
  }
  if (!token && !route.public) {
    return <Navigate to="/login" />;
  }

  return route.element;
}
